export const actionTypes = {
  REQUEST_GET_SERVICE_BALANCE: 'REQUEST_GET_SERVICE_BALANCE',
  SUCCESS_GET_SERVICE_BALANCE: 'SUCCESS_GET_SERVICE_BALANCE',
  ERROR_GET_SERVICE_BALANCE: 'ERROR_GET_SERVICE_BALANCE',
  RESET_GET_SERVICE_BALANCE: 'RESET_GET_SERVICE_BALANCE',
  REQUEST_LOVE_BOX_REDEEM: 'REQUEST_LOVE_BOX_REDEEM',
  SUCCESS_LOVE_BOX_REDEEM: 'SUCCESS_LOVE_BOX_REDEEM',
  ERROR_LOVE_BOX_REDEEM: 'ERROR_LOVE_BOX_REDEEM',
  RESET_LOVE_BOX_REDEEM: 'RESET_LOVE_BOX_REDEEM',
}